import { styled } from '@mui/material'
import FormControl from '@mui/material/FormControl'

export const StyledFormControl = styled(FormControl)`
  min-width: 120px;
  flex-grow: 0;
`
